import { conflictMessages } from '@fusapp-work/ui-kit/cosmos/locales'
import trRoot from './tr.json'
import enRoot from './en.json'
import { tr as trShell, en as enShell } from '../components/shell/locales'

import trOrganization from '../features/organization/locales/tr'
import enOrganization from '../features/organization/locales/en'

import { tr as trPersonnel, en as enPersonnel } from '../features/organization/personnel/locales'
import { tr as trAudit, en as enAudit } from '../features/organization/audit/locales'

import { tr as trRoles, en as enRoles } from '../features/organization/roles/locales'
import { tr as trEntra, en as enEntra } from '../features/identity/entra/locales'
import { tr as trWelcome, en as enWelcome } from '../features/identity/welcome/locales'
import { tr as trChannels, en as enChannels } from '../features/communication/channels/locales'

import { tr as trTemplates, en as enTemplates } from '../features/communication/templates/locales'
import { tr as trTransactions, en as enTransactions } from '../features/communication/transactions/locales'

export const messages = {
  tr: { ...trRoot, conflictNotice: conflictMessages.tr, consoleShell: trShell, consolePersonnel: trPersonnel, consoleAudit: trAudit, consoleRoles: trRoles, consoleEntra: trEntra, consoleWelcome: trWelcome, consoleChannels: trChannels, consoleTemplates: trTemplates, consoleTransactions: trTransactions, organization: trOrganization },
  en: { ...enRoot, conflictNotice: conflictMessages.en, consoleShell: enShell, consolePersonnel: enPersonnel, consoleAudit: enAudit, consoleRoles: enRoles, consoleEntra: enEntra, consoleWelcome: enWelcome, consoleChannels: enChannels, consoleTemplates: enTemplates, consoleTransactions: enTransactions, organization: enOrganization },
}
